// Form validation for SLA
import ruleBuilder from '../utils/RuleBuilder';

// TODO: Validators for sla timings when state stucture is changed

const config = {};

export default {
  name: {
    presence: {
      allowEmpty: false,
      message: '^Enter view name'
    }
  },
  'personalization.value': {
    presence: {
      allowEmpty: false,
      message: '^Add a column'
    }
  },
  viewCondition: { presence: { allowEmpty: false } },
  ...ruleBuilder('viewCondition.operands')
};
